exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".less-jumpy-spin-animation[data-v-70e43696] {\n  animation: spin-data-v-70e43696 2s infinite linear;\n}\n@keyframes spin-data-v-70e43696 {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(359deg);\n}\n}\n", ""]);

// exports
